// ./src/styles/theme/index.ts
import React from "react";
import { createTheme /*, virtualColor*/ } from "@mantine/core";
import {
  venueBoardsBlue,
  venueBoardsGreen,
  venueBoardsOrange,
  venueBoardsRed,
  venueBoardsGray,
  //semanticColors,
} from "./colors";
import { fonts } from "./fonts";
//import { breakpoints } from "./breakpoints";
//import { components } from "./components";

// Enhanced Event Row Theme Configuration Interface using standard CSS properties
export interface EventRowElementConfig {
  // Each element can use any CSS property
  container: React.CSSProperties;
  timeBadge: React.CSSProperties;
  timeBadgeText: React.CSSProperties;
  statusBadge: React.CSSProperties;
  recurrenceBadge: React.CSSProperties;
  eventTitle: React.CSSProperties;
  teamName: React.CSSProperties;
  details: React.CSSProperties;

  // Accent colors for potential animations/effects (non-CSS)
  accent: {
    primaryColor: string;
    secondaryColor?: string;
    glowColor?: string;
  };
}

export interface EventRowThemeConfig {
  future: EventRowElementConfig;
  upcoming: EventRowElementConfig;
  ongoing: EventRowElementConfig;
  ending: EventRowElementConfig;
  ended: EventRowElementConfig;
  canceled: EventRowElementConfig;
}

const fontSizeTimeBadgeText = "1.3rem";
const fontSizeEventTitle = "1.3rem";
const fontSizeTeamName = "1.2rem";
const fontSizeDetails = "1.2rem";

// Default configuration with sensible defaults
export const defaultEventRowThemeConfig: EventRowThemeConfig = {
  future: {
    container: {
      background: "var(--mantine-color-white)",
      //"linear-gradient(135deg, var(--mantine-color-gray-1) 0%, var(--mantine-color-blue-0) 50%, var(--mantine-color-gray-0) 100%)",
      //borderColor: "var(--mantine-color-gray-3)",
      //borderLeftColor: "var(--mantine-color-cyan-7)",
      borderWidth: "0px",
      borderLeftWidth: "6px",
      borderRadius: "var(--mantine-radius-lg)",
      padding: "var(--mantine-spacing-sm)",
      marginBottom: "var(--mantine-spacing-xs)",
      color: "var(--mantine-color-gray-8)",
      fontSize: "var(--mantine-font-size-md)",
      fontWeight: "500",
      borderStyle: "solid",
    },
    timeBadge: {
      background: "linear-gradient(135deg, #6879e2 0%, #764ea7 100%)",
      borderColor: "var(#764ea7)",
      borderWidth: "3px",
      borderRadius: "var(--mantine-radius-md)",
      padding: "4px var(--mantine-spacing-sm)",
      width: "300px",
      maxWidth: "33%",
      flexShrink: 0,
      color: "var(--mantine-color-white)",
      fontSize: fontSizeTimeBadgeText,
      fontWeight: "900",
    },
    timeBadgeText: {
      color: "inherit",
      fontSize: "inherit",
      fontWeight: "inherit",
      fontFamily: "inherit",
      letterSpacing: "0.5px",
      textAlign: "center",
      //textShadow: "0 0 10px #555",
    },
    statusBadge: {
      // backgroundColor: "var(--mantine-color-gray-5)",
      // color: "var(--mantine-color-white)",
      borderRadius: "var(--mantine-radius-lg)",
      padding: "4px var(--mantine-spacing-sm)",
      // fontSize: "var(--mantine-font-size-md)",
      // fontWeight: "800",
      letterSpacing: "1px",
      textTransform: "uppercase",
    },
    recurrenceBadge: {
      backgroundColor: "var(--mantine-color-blue-5)",
      color: "var(--mantine-color-white)",
      borderRadius: "var(--mantine-radius-md)",
      padding: "4px var(--mantine-spacing-sm)",
      fontSize: "var(--mantine-font-size-md)",
      fontWeight: "800",
      letterSpacing: "1px",
      textTransform: "uppercase",
    },
    eventTitle: {
      color: "inherit",
      fontSize: fontSizeEventTitle,
      fontWeight: "800",
      textTransform: "uppercase",
      letterSpacing: "0.8px",
      lineHeight: "1.1",
    },
    teamName: {
      color: "inherit",
      fontSize: fontSizeTeamName,
      fontWeight: "700",
    },
    details: {
      color: "inherit",
      fontSize: fontSizeDetails,
      fontWeight: "500",
    },
    accent: {
      primaryColor: "var(--mantine-color-blue-4)",
    },
  },
  upcoming: {
    container: {
      background: "var(--mantine-color-white)",
      //"linear-gradient(135deg, var(--mantine-color-gray-1) 0%, var(--mantine-color-blue-0) 50%, var(--mantine-color-gray-0) 100%)",
      // borderColor: "var(--mantine-color-gray-3)",
      // borderLeftColor: "var(--mantine-color-yellow-7)",
      borderWidth: "0px",
      borderLeftWidth: "6px",
      borderRadius: "var(--mantine-radius-lg)",
      padding: "var(--mantine-spacing-sm)",
      marginBottom: "var(--mantine-spacing-xs)",
      color: "var(--mantine-color-gray-8)",
      fontSize: "var(--mantine-font-size-md)",
      fontWeight: "500",
      borderStyle: "solid",
    },
    timeBadge: {
      background: "linear-gradient(135deg, #6879e2 0%, #764ea7 100%)",
      borderColor: "var(#764ea7)",
      borderWidth: "3px",
      borderRadius: "var(--mantine-radius-md)",
      padding: "4px var(--mantine-spacing-sm)",
      width: "300px",
      maxWidth: "33%",
      flexShrink: 0,
    },
    timeBadgeText: {
      color: "inherit",
      fontSize: "inherit",
      fontWeight: "inherit",
      fontFamily: "inherit",
      letterSpacing: "0.5px",
      textAlign: "center",
      //textShadow: "0 0 10px #555",
    },
    statusBadge: {
      // background: "var(--mantine-color-yellow-5)",
      // color: "var(--mantine-color-white)",
      // borderColor: "var(--mantine-color-yellow-5)",
      // borderWidth: "1px",
      borderRadius: "var(--mantine-radius-md)",
      padding: "4px var(--mantine-spacing-sm)",
      //fontSize: "var(--mantine-font-size-sm)",
      // fontWeight: "800",
      // boxShadow:
      //   "0 3px 12px rgba(0, 0, 0, 0.2), 0 1px 6px var(--mantine-color-yellow-5)50",
      letterSpacing: "1px",
      textTransform: "uppercase",
    },
    recurrenceBadge: {
      backgroundColor: "var(--mantine-color-blue-5)",
      color: "var(--mantine-color-white)",
      borderRadius: "var(--mantine-radius-md)",
      padding: "4px var(--mantine-spacing-sm)",
      fontSize: "var(--mantine-font-size-md)",
      fontWeight: "800",
      letterSpacing: "1px",
      textTransform: "uppercase",
    },
    eventTitle: {
      color: "inherit",
      fontSize: fontSizeEventTitle,
      fontWeight: "800",
      textTransform: "uppercase",
      letterSpacing: "0.8px",
      lineHeight: "1.1",
    },
    teamName: {
      color: "inherit",
      fontSize: fontSizeTeamName,
      fontWeight: "700",
    },
    details: {
      color: "inherit",
      fontSize: fontSizeDetails,
      fontWeight: "500",
      opacity: "0.9",
    },
    accent: {
      primaryColor: "var(--mantine-color-cyan-3)",
      secondaryColor: "var(--mantine-color-yellow-4)",
      glowColor: "var(--mantine-color-cyan-2)",
    },
  },

  ongoing: {
    container: {
      background: "var(--mantine-color-white)",
      // "linear-gradient(135deg, var(--mantine-color-gray-1) 0%, var(--mantine-color-blue-0) 50%, var(--mantine-color-gray-0) 100%)",
      // borderColor: "var(--mantine-color-gray-3)",
      // borderLeftColor: "var(--mantine-color-lime-7)",
      borderWidth: "0px",
      borderLeftWidth: "6px",
      borderRadius: "var(--mantine-radius-lg)",
      padding: "var(--mantine-spacing-sm)",
      marginBottom: "var(--mantine-spacing-xs)",
      color: "var(--mantine-color-gray-8)",
      fontSize: "var(--mantine-font-size-md)",
      fontWeight: "500",
      borderStyle: "solid",
    },
    timeBadge: {
      background: "linear-gradient(135deg, #6879e2 0%, #764ea7 100%)",
      borderColor: "var(#764ea7)",
      borderWidth: "3px",
      borderRadius: "var(--mantine-radius-md)",
      padding: "4px var(--mantine-spacing-sm)",
      width: "300px",
      maxWidth: "33%",
      flexShrink: 0,
    },
    timeBadgeText: {
      color: "inherit",
      fontSize: "inherit",
      fontWeight: "inherit",
      fontFamily: "inherit",
      letterSpacing: "0.5px",
      textAlign: "center",
      //textShadow: "0 0 10px #555",
    },
    statusBadge: {
      // background: "var(--mantine-color-lime-6)",
      // color: "var(--mantine-color-white)",
      borderRadius: "var(--mantine-radius-lg)",
      padding: "var(--mantine-spacing-xs)",
      // fontSize: "var(--mantine-font-size-sm)",
      // fontWeight: "800",
      // boxShadow:
      //   "0 4px 16px rgba(0, 0, 0, 0.2), 0 2px 8px var(--mantine-color-lime-6)60",
      letterSpacing: "1px",
      textTransform: "uppercase",
    },
    recurrenceBadge: {
      backgroundColor: "var(--mantine-color-blue-5)",
      color: "var(--mantine-color-white)",
      borderRadius: "var(--mantine-radius-md)",
      padding: "4px var(--mantine-spacing-sm)",
      fontSize: "var(--mantine-font-size-md)",
      fontWeight: "800",
      letterSpacing: "1px",
      textTransform: "uppercase",
    },
    eventTitle: {
      color: "inherit",
      fontSize: fontSizeEventTitle,
      fontWeight: "800",
      textTransform: "uppercase",
      letterSpacing: "0.8px",
      lineHeight: "1.1",
    },
    teamName: {
      color: "inherit",
      fontSize: fontSizeTeamName,
      fontWeight: "700",
    },
    details: {
      color: "inherit",
      fontSize: fontSizeDetails,
      fontWeight: "500",
      opacity: "0.9",
    },
    accent: {
      primaryColor: "var(--mantine-color-lime-3)",
      secondaryColor: "var(--mantine-color-teal-3)",
      glowColor: "var(--mantine-color-lime-2)",
    },
  },

  ending: {
    container: {
      background: "var(--mantine-color-white)",
      //"linear-gradient(135deg, var(--mantine-color-gray-1) 0%, var(--mantine-color-blue-0) 50%, var(--mantine-color-gray-0) 100%)",
      // borderColor: "var(--mantine-color-gray-3)",
      // borderLeftColor: "var(--mantine-color-red-7)",
      borderWidth: "0px",
      borderLeftWidth: "6px",
      borderRadius: "var(--mantine-radius-lg)",
      padding: "var(--mantine-spacing-sm)",
      marginBottom: "var(--mantine-spacing-xs)",
      color: "var(--mantine-color-gray-8)",
      fontSize: "var(--mantine-font-size-md)",
      fontWeight: "500",
      borderStyle: "solid",
    },
    timeBadge: {
      background: "linear-gradient(135deg, #6879e2 0%, #764ea7 100%)",
      borderColor: "var(#764ea7)",
      borderWidth: "3px",
      borderRadius: "var(--mantine-radius-md)",
      padding: "4px var(--mantine-spacing-sm)",
      width: "300px",
      maxWidth: "33%",
      flexShrink: 0,
    },
    timeBadgeText: {
      color: "inherit",
      fontSize: "inherit",
      fontWeight: "inherit",
      fontFamily: "inherit",
      letterSpacing: "0.5px",
      textAlign: "center",
      //textShadow: "0 0 10px #555",
    },
    statusBadge: {
      // background: "var(--mantine-color-red-6)",
      // color: "var(--mantine-color-white)",
      // borderColor: "var(--mantine-color-red-6)",
      // borderWidth: "2px",
      borderRadius: "var(--mantine-radius-lg)",
      padding: "var(--mantine-spacing-xs)",
      // fontSize: "var(--mantine-font-size-sm)",
      // fontWeight: "800",
      // boxShadow:
      //   "0 4px 16px rgba(0, 0, 0, 0.2), 0 2px 8px var(--mantine-color-red-6)60",
      letterSpacing: "1px",
      textTransform: "uppercase",
    },
    recurrenceBadge: {
      backgroundColor: "var(--mantine-color-blue-5)",
      color: "var(--mantine-color-white)",
      borderRadius: "var(--mantine-radius-md)",
      padding: "4px var(--mantine-spacing-sm)",
      fontSize: "var(--mantine-font-size-md)",
      fontWeight: "800",
      letterSpacing: "1px",
      textTransform: "uppercase",
    },
    eventTitle: {
      color: "inherit",
      fontSize: fontSizeEventTitle,
      fontWeight: "800",
      textTransform: "uppercase",
      letterSpacing: "0.8px",
      lineHeight: "1.1",
    },
    teamName: {
      color: "inherit",
      fontSize: fontSizeTeamName,
      fontWeight: "700",
    },
    details: {
      color: "inherit",
      fontSize: fontSizeDetails,
      fontWeight: "500",
      opacity: "0.9",
    },
    accent: {
      primaryColor: "var(--mantine-color-pink-3)",
      secondaryColor: "var(--mantine-color-orange-3)",
      glowColor: "var(--mantine-color-pink-2)",
    },
  },

  ended: {
    container: {
      background: "var(--mantine-color-white)",
      //"linear-gradient(135deg, var(--mantine-color-gray-1) 0%, var(--mantine-color-blue-0) 50%, var(--mantine-color-gray-0) 100%)",
      // borderColor: "var(--mantine-color-gray-3)",
      // borderLeftColor: "var(--mantine-color-red-7)",
      borderWidth: "0px",
      borderLeftWidth: "6px",
      borderRadius: "var(--mantine-radius-lg)",
      padding: "var(--mantine-spacing-sm)",
      marginBottom: "var(--mantine-spacing-xs)",
      color: "var(--mantine-color-gray-8)",
      fontSize: "var(--mantine-font-size-md)",
      fontWeight: "500",
      borderStyle: "solid",
    },
    timeBadge: {
      background: "linear-gradient(135deg, #6879e2 0%, #764ea7 100%)",
      borderColor: "var(#764ea7)",
      borderWidth: "3px",
      borderRadius: "var(--mantine-radius-md)",
      padding: "4px var(--mantine-spacing-sm)",
      width: "300px",
      maxWidth: "33%",
      flexShrink: 0,
    },
    timeBadgeText: {
      color: "inherit",
      fontSize: "inherit",
      fontWeight: "inherit",
      fontFamily: "inherit",
      letterSpacing: "0.5px",
      textAlign: "center",
      //textShadow: "0 0 10px #555",
    },
    statusBadge: {
      // background: "var(--mantine-color-red-6)",
      // color: "var(--mantine-color-white)",
      // borderColor: "var(--mantine-color-red-6)",
      // borderWidth: "2px",
      borderRadius: "var(--mantine-radius-lg)",
      padding: "var(--mantine-spacing-xs)",
      // fontSize: "var(--mantine-font-size-sm)",
      // fontWeight: "800",
      // boxShadow:
      //   "0 4px 16px rgba(0, 0, 0, 0.2), 0 2px 8px var(--mantine-color-red-6)60",
      letterSpacing: "1px",
      textTransform: "uppercase",
    },
    recurrenceBadge: {
      backgroundColor: "var(--mantine-color-blue-5)",
      color: "var(--mantine-color-white)",
      borderRadius: "var(--mantine-radius-md)",
      padding: "4px var(--mantine-spacing-sm)",
      fontSize: "var(--mantine-font-size-md)",
      fontWeight: "800",
      letterSpacing: "1px",
      textTransform: "uppercase",
    },
    eventTitle: {
      color: "inherit",
      fontSize: fontSizeEventTitle,
      fontWeight: "800",
      textTransform: "uppercase",
      letterSpacing: "0.8px",
      lineHeight: "1.1",
    },
    teamName: {
      color: "inherit",
      fontSize: fontSizeTeamName,
      fontWeight: "700",
    },
    details: {
      color: "inherit",
      fontSize: fontSizeDetails,
      fontWeight: "500",
      opacity: "0.9",
    },
    accent: {
      primaryColor: "var(--mantine-color-pink-3)",
      secondaryColor: "var(--mantine-color-orange-3)",
      glowColor: "var(--mantine-color-pink-2)",
    },
  },

  canceled: {
    container: {
      background: "var(--mantine-color-white)",
      //"linear-gradient(135deg, var(--mantine-color-gray-1) 0%, var(--mantine-color-blue-0) 50%, var(--mantine-color-gray-0) 100%)",
      // borderColor: "var(--mantine-color-gray-3)",
      // borderLeftColor: "var(--mantine-color-gray-7)",
      borderWidth: "0px",
      borderLeftWidth: "6px",
      borderRadius: "var(--mantine-radius-lg)",
      padding: "var(--mantine-spacing-sm)",
      marginBottom: "var(--mantine-spacing-xs)",
      color: "var(--mantine-color-gray-8)",
      fontSize: "var(--mantine-font-size-md)",
      fontWeight: "500",
      borderStyle: "solid",
    },
    timeBadge: {
      background: "linear-gradient(135deg, #6879e2 0%, #764ea7 100%)",
      borderColor: "var(#764ea7)",
      borderWidth: "3px",
      borderRadius: "var(--mantine-radius-md)",
      padding: "4px var(--mantine-spacing-sm)",
      width: "300px",
      maxWidth: "33%",
      flexShrink: 0,
    },
    timeBadgeText: {
      color: "inherit",
      fontSize: "inherit",
      fontWeight: "inherit",
      fontFamily: "inherit",
      letterSpacing: "0.5px",
      textAlign: "center",
      //textShadow: "0 0 10px #555",
    },
    statusBadge: {
      // background: "var(--mantine-color-red-6)",
      // color: "var(--mantine-color-white)",
      borderRadius: "var(--mantine-radius-lg)",
      padding: "var(--mantine-spacing-xs)",
      // fontSize: "var(--mantine-font-size-sm)",
      // fontWeight: "800",
      // boxShadow: "0 3px 12px rgba(0, 0, 0, 0.2)",
      letterSpacing: "1px",
      textTransform: "uppercase",
    },
    recurrenceBadge: {
      backgroundColor: "var(--mantine-color-blue-5)",
      color: "var(--mantine-color-white)",
      borderRadius: "var(--mantine-radius-md)",
      padding: "4px var(--mantine-spacing-sm)",
      fontSize: "var(--mantine-font-size-md)",
      fontWeight: "800",
      letterSpacing: "1px",
      textTransform: "uppercase",
    },
    eventTitle: {
      color: "inherit",
      fontSize: fontSizeEventTitle,
      fontWeight: "800",
      textTransform: "uppercase",
      letterSpacing: "0.8px",
      lineHeight: "1.1",
    },
    teamName: {
      color: "inherit",
      fontSize: fontSizeTeamName,
      fontWeight: "700",
    },
    details: {
      color: "inherit",
      fontSize: fontSizeDetails,
      fontWeight: "500",
      opacity: "0.9",
    },
    accent: {
      primaryColor: "var(--mantine-color-red-4)",
    },
  },
};

// VenueBoards Main Theme Configuration
export const venueBoardsTheme = createTheme({
  // Color configuration
  colors: {
    // Brand colors
    primary: venueBoardsBlue,
    secondary: venueBoardsGreen,
    accent: venueBoardsOrange,
    danger: venueBoardsRed,
    neutral: venueBoardsGray,
    // Virtual colors for semantic meanings
    /* arena: virtualColor({
      name: "arena",
      dark: venueBoardsBlue[6],
      light: venueBoardsBlue[6],
    }),
    dressingRoom: virtualColor({
      name: "dressingRoom",
      dark: venueBoardsGreen[6],
      light: venueBoardsGreen[6],
    }),
    conferenceRoom: virtualColor({
      name: "conferenceRoom",
      dark: venueBoardsOrange[6],
      light: venueBoardsOrange[6],
    }),
    kitchen: virtualColor({
      name: "kitchen",
      dark: venueBoardsRed[6],
      light: venueBoardsRed[6],
    }), */
  },

  // Set primary color
  primaryColor: "primary",
  primaryShade: { light: 6, dark: 8 },

  // Typography
  fontFamily: fonts.primary,
  fontFamilyMonospace: fonts.monospace,

  // Font sizes
  /*  fontSizes: {
    xs: fonts.sizes.xs,
    sm: fonts.sizes.sm,
    md: fonts.sizes.md,
    lg: fonts.sizes.lg,
    xl: fonts.sizes.xl,
  }, */

  // Line heights
  /* lineHeights: {
    xs: fonts.lineHeights.tight.toString(),
    sm: fonts.lineHeights.tight.toString(),
    md: fonts.lineHeights.normal.toString(),
    lg: fonts.lineHeights.normal.toString(),
    xl: fonts.lineHeights.relaxed.toString(),
  }, */

  // Headings configuration
  /* headings: {
    fontFamily: fonts.primary,
    fontWeight: fonts.weights.semibold.toString(),
    sizes: {
      h1: {
        fontSize: fonts.sizes.h1,
        lineHeight: fonts.lineHeights.tight.toString(),
        fontWeight: fonts.weights.bold.toString(),
      },
      h2: {
        fontSize: fonts.sizes.h2,
        lineHeight: fonts.lineHeights.tight.toString(),
        fontWeight: fonts.weights.semibold.toString(),
      },
      h3: {
        fontSize: fonts.sizes.h3,
        lineHeight: fonts.lineHeights.tight.toString(),
        fontWeight: fonts.weights.semibold.toString(),
      },
      h4: {
        fontSize: fonts.sizes.h4,
        lineHeight: fonts.lineHeights.normal.toString(),
        fontWeight: fonts.weights.medium.toString(),
      },
      h5: {
        fontSize: fonts.sizes.h5,
        lineHeight: fonts.lineHeights.normal.toString(),
        fontWeight: fonts.weights.medium.toString(),
      },
      h6: {
        fontSize: fonts.sizes.h6,
        lineHeight: fonts.lineHeights.normal.toString(),
        fontWeight: fonts.weights.medium.toString(),
      },
    },
  }, */

  // Spacing
  /* spacing: {
    xs: "4px",
    sm: "8px",
    md: "16px",
    lg: "24px",
    xl: "32px",
  }, */

  // Border radius
  /* radius: {
    xs: "4px",
    sm: "6px",
    md: "8px",
    lg: "12px",
    xl: "16px",
  }, */

  // Shadows
  /* shadows: {
    xs: "0 1px 3px rgba(0, 0, 0, 0.1)",
    sm: "0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06)",
    md: "0 4px 6px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06)",
    lg: "0 10px 15px rgba(0, 0, 0, 0.1), 0 4px 6px rgba(0, 0, 0, 0.05)",
    xl: "0 20px 25px rgba(0, 0, 0, 0.1), 0 10px 10px rgba(0, 0, 0, 0.04)",
  }, */

  // Breakpoints
  //breakpoints,

  // Component overrides
  //components,

  // Other theme settings
  /* defaultRadius: "md",
  focusRing: "auto",
  cursorType: "pointer",
  respectReducedMotion: true, */

  // Custom properties for VenueBoards
  other: {
    // Event Row Theme Configuration
    eventRowTheme: defaultEventRowThemeConfig,

    // Semantic colors for easy access
    //semantic: semanticColors,

    // Animation durations
    animations: {
      fast: "150ms",
      normal: "250ms",
      slow: "400ms",
    },

    // Z-index scale
    zIndex: {
      dropdown: 1000,
      sticky: 1020,
      fixed: 1030,
      modal: 1040,
      popover: 1050,
      tooltip: 1060,
      notification: 1070,
      emergency: 9999,
    },

    // TV Display specific settings
    tvDisplay: {
      // Larger spacing for TV screens
      padding: "48px",
      itemSpacing: "32px",

      // TV-optimized font sizes
      fontSize: {
        small: "24px",
        medium: "32px",
        large: "48px",
        xlarge: "64px",
        display: "96px",
      },

      // TV color scheme (higher contrast)
      colors: {
        background: "#ffffff",
        text: "#1a1a1a",
        accent: venueBoardsBlue[6],
        success: venueBoardsGreen[6],
        warning: venueBoardsOrange[6],
        error: venueBoardsRed[6],
      },
    },

    // Status colors for different entity states
    /* status: {
      venue: {
        active: semanticColors.success,
        inactive: semanticColors.offline,
        maintenance: semanticColors.warning,
      },
      event: {
        confirmed: semanticColors.confirmed,
        pending: semanticColors.pending,
        cancelled: semanticColors.cancelled,
        inProgress: semanticColors.info,
      },
      room: {
        available: semanticColors.available,
        occupied: semanticColors.occupied,
        maintenance: semanticColors.maintenance,
        cleaning: semanticColors.warning,
      },
              display: {
        online: semanticColors.online,
        offline: semanticColors.offline,
        connecting: semanticColors.connecting,
        error: semanticColors.emergency,
      },
    }, */
  },
});

// Helper function to update event row theme configuration
export const updateEventRowTheme = (
  newTheme: Partial<EventRowThemeConfig>
): EventRowThemeConfig => {
  return {
    ...defaultEventRowThemeConfig,
    ...newTheme,
  };
};

// Helper function to get semantic color
/* export const getSemanticColor = (category: string, status: string): string => {
  const statusColors = venueBoardsTheme.other?.status as any;

  if (
    statusColors &&
    statusColors[category] &&
    statusColors[category][status]
  ) {
    return statusColors[category][status];
  }

  return venueBoardsGray[5]; // fallback color
}; */

// Helper function to get room type color
/* export const getRoomTypeColor = (roomType: string): string => {
  const normalizedType = roomType.toLowerCase().replace(/\s+/g, "");

  switch (normalizedType) {
    case "arena":
    case "rink":
    case "ice":
      return semanticColors.arena;
    case "dressingroom":
    case "locker":
    case "changeroom":
      return semanticColors.dressingRoom;
    case "conferenceroom":
    case "meeting":
    case "office":
      return semanticColors.conferenceRoom;
    case "kitchen":
    case "concession":
    case "cafe":
      return semanticColors.kitchen;
    default:
      return venueBoardsGray[6];
  }
}; */

// Helper function for TV display styling
/* export const getTVDisplayStyles = (
  size: "small" | "medium" | "large" | "xlarge" | "display" = "medium"
) => {
  const tvConfig = venueBoardsTheme.other?.tvDisplay as any;

  return {
    fontSize: tvConfig?.fontSize?.[size] || "32px",
    padding: tvConfig?.padding || "48px",
    color: tvConfig?.colors?.text || "#1a1a1a",
    fontWeight: 600,
    letterSpacing: "0.5px",
  };
}; */

// Export theme and utilities
//export { semanticColors, fonts, breakpoints, components };
export default venueBoardsTheme;
